import styled, { css } from "styled-components"

export default {
    "Button": styled.button`
        width: 100%;
        height: ${({ $small }) => $small ? "24px" : "36px"};
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: ${({ theme }) => theme.color["black"]};
        color: ${({ theme }) => theme.color["white"]};
        ${({ theme, $small }) => $small ? theme.font["small-regular"] : theme.font["large-semibold"]};
        border-radius: 4px;

        ${({ $deactive }) => $deactive && css`
            background-color: ${({ theme }) => theme.color["grey2"]};
            color: ${({ theme }) => theme.color["grey4"]};
        `}

        ${({ $caution }) => $caution && css`
            background-color: ${({ theme }) => theme.color["error"]};
            color: ${({ theme }) => theme.color["white"]};
        `}
    `,
}